<template>
  <div class="m-shifts">
    <b-modal id="shifts-modal" v-model="active" size="custom-size" centered hide-footer @close="active = false">
      <template #modal-title> Показывать в таблице должности: </template>

      <shadow-scroll-container class="scroll">
        <div>
          <c-input
            v-model="query"
            class="search"
            placeholder="Поиск по должности"
            type="text"
            :clearable="true"
            icon="search"
          />
        </div>
        <div v-if="!filteredList.length" class="empty">Должности не найдены</div>
        <div v-else class="list">
          <div v-for="position in filteredList" :key="position.code" class="list-item">
            <c-switcher
              type="checkbox"
              :label="position.name"
              :value="visible.includes(position.code)"
              @input="togglePosition(position, $event)"
            />
          </div>
        </div>
      </shadow-scroll-container>

      <div class="m-shifts-buttons">
        <c-button class="reset" size="large" label="Сбросить" @click="close" />

        <c-button class="apply" size="large" label="Применить" color="blue" @click="apply" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import CButton from "@/components/controls/button";
import CSwitcher from "@/components/controls/switcher";
import CInput from "@/components/controls/input";
import ShadowScrollContainer from "@/components/shadow-scroll-container";

export default {
  components: {
    CButton,
    CSwitcher,
    CInput,
    ShadowScrollContainer,
  },

  props: ["positions"],

  data() {
    return {
      active: false,
      query: "",

      visible: [],
    };
  },

  computed: {
    formattedQuery() {
      return this.query.trim().toLowerCase();
    },

    filteredList() {
      if (!this.formattedQuery) return this.positions;
      const query = this.formattedQuery;
      return this.positions.filter((p) => { 
        return p.name.toLowerCase().includes(query);
      });
    },
  },

  watch: {},

  mounted() {},

  methods: {
    open(params) {
      this.query = "";
      this.visible = params.visible;

      this.active = true;
    },

    close() {
      this.active = false;
      this.$emit("close");
    },

    apply() {
      this.$emit("apply", this.visible);
      this.close();
    },

    togglePosition(position, value) {
      if (value) {
        this.visible = [...this.visible, position.code];
      } else {
        this.visible = this.visible.filter((i) => i !== position.code);
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/styles/vars";
.scroll {
  height: 350px;
  padding-top: 0px;
}
.search {
  margin-bottom: 24px;

  & /deep/ {
    .c-input-input::placeholder {
      font-style: italic;
    }
  }
}
.list {
  &-item {
    margin-bottom: 20px;
  }
}
.m-shifts-buttons {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;

  .reset {
    margin-right: 10px;
  }
}
.empty {
  font-size: 14px;
}
@include onlyMobile {
  /deep/ {
    .modal-title {
      font-size: 18px;
      font-weight: 500;
      line-height: 1.2;
    }
  }

  .scroll {
    flex-grow: 1;
  }

  .m-shifts-buttons {
    margin-left: -21px;
    margin-right: -21px;
    margin-top: 0;

    background: #ffffff;
    box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);

    .reset,
    .apply {
      width: 50%;
      margin: 0;

      & /deep/ {
        .c-button__wrapper {
          width: 100%;
          border-radius: 0;
          justify-content: center;
        }
      }
    }
  }

  & /deep/ {
    .modal-body {
      padding-bottom: 0;
    }
  }
}
</style>
